// extracted by mini-css-extract-plugin
export default {"loader":"StyledLoader_loader__AvIso","spin":"StyledLoader_spin__-Ee-Y","rotate":"StyledLoader_rotate__Spb03","rotateccw":"StyledLoader_rotateccw__OHHdv"};